import React, { useEffect, useState } from "react";
import { getData } from "../services/api.service";
import { useNavigate } from "react-router-dom";
import { swalAlertDanger } from "../components/common/Alerts";
import Logo from "../assets/img/Logo2.png";
import BackButton from "../components/common/BackButton";

const BranchSelectionUser = () => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Obtener sucursales activas
        const res = await getData("/api/get_branches");
        if (res.status === 200) {
          // Mostrar todas las sucursales activas (abiertas y cerradas)
          const activeBranches = (res.data.branches || res.data).filter(
            branch => branch.active === 1
          );
          setBranches(activeBranches);
        } else {
          swalAlertDanger(
            "Error al obtener las sucursales",
            "",
            () => {}
          );
        }
      } catch (error) {
        swalAlertDanger("Error al obtener los datos", "", () => {});
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleBranchSelection = (branchId) => {
    navigate(`/home/food_order/${branchId}`);
  };

  return (
    <div className="container text-white mt-3">
      <div className="mb-5">
        <BackButton />
      </div>
      
      <div className="text-center mb-4">
        <img src={Logo} alt="Logo" className="w-25 mb-3" />
        <h1>¿Dónde querés hacer tu pedido?</h1>
        <p className="lead">Selecciona la sucursal de tu preferencia</p>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : branches.length === 0 ? (
        <div className="alert alert-warning text-center my-5" role="alert">
          <h4>🔒 Sin sucursales disponibles</h4>
          <p className="mb-0">
            Actualmente no hay sucursales abiertas para recibir pedidos.
          </p>
          <small>Intenta más tarde.</small>
        </div>
      ) : (
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="d-grid gap-3">
              {branches.map((branch) => {
                const isClosed = branch.closed === 1;
                return (
                  <div
                    key={branch.id}
                    className={`btn-outline-light btn-lg p-4 text-start border rounded text-white position-relative ${
                      isClosed ? 'bg-secondary opacity-75' : 'bg-dark'
                    }`}
                    style={{ 
                      cursor: isClosed ? "not-allowed" : "pointer",
                      pointerEvents: isClosed ? "none" : "auto"
                    }}
                    onClick={() => !isClosed && handleBranchSelection(branch.id)}
                  >
                    {isClosed && (
                      <div 
                        className="position-absolute top-50 start-50 translate-middle"
                        style={{ 
                          fontSize: "1.2rem", 
                          fontWeight: "bold",
                          color: "#fff",
                          backgroundColor: "rgba(220, 53, 69, 0.9)",
                          padding: "10px 20px",
                          borderRadius: "8px",
                          zIndex: 5
                        }}
                      >
                        🔒 SUCURSAL CERRADA
                      </div>
                    )}
                    
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h4 className="mb-1">{branch.branch_name}</h4>
                        <p className="mb-1 text-white">📍 {branch.address}</p>
                        {branch.phone && (
                          <small className="text-white">📞 {branch.phone}</small>
                        )}
                      </div>
                      <div className="text-end">
                        <span className={`badge fs-6 ${isClosed ? 'bg-danger' : 'bg-success'}`}>
                          {isClosed ? '🔴 Cerrada' : '🟢 Abierta'}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <div className="text-center mt-5">
        <img src={Logo} alt="LogoBottom" className="w-25 opacity-50" />
      </div>
    </div>
  );
};

export default BranchSelectionUser;
